<template>
  <div class="albumsList">
    <div class="albumsList_header">
      <div class="header_title">
        <h2>アルバム一覧</h2>
        <p class="header_value">{{ albumsList.length }}件</p>
      </div>
      <BtnToggle v-bind:toggle="toggle" @toggleAction="toggle = $event" />
    </div>
    <div class="albumsList_list_wrapper">
      <ul
        class="albumsList_list"
        v-bind:class="{
          slider: toggle == 'slider',
          column: toggle == 'column',
        }"
      >
        <li class="item" v-for="(item, index) in albumsList" :key="index">
          <button
            @click="
              $router.push({ name: `Challenge`, params: { cid: item.id } })
            "
          >
            <p class="item_title">
              {{ item.data.data.name }}
            </p>
            <p class="item_img">
              <img :src="item.data.thumbnail" />
            </p>
            <p class="item_footer">
              <span>{{ item.data.post }}</span
              >枚・
              <span>
                {{ displayTime(new Date(item.data.update.seconds * 1000)) }}
              </span>
            </p>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BtnToggle from "@/components/parts/BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  props: ["albumsList"],
  data() {
    return {
      toggle: "slider",
    };
  },
  methods: {
    displayTime(unixTime) {
      var date = new Date(unixTime);
      var diff = new Date().getTime() - date.getTime();
      var d = new Date(diff);

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + "年前";
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + "ヶ月前";
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + "日前";
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + "時間前";
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + "分前";
      } else {
        return d.getUTCSeconds() + "秒前";
      }
    },
  },
};
</script>

<style lang="scss">
.albumsList {
  @include Section_padding();
  &_header {
    @include Section_header();
  }
  &_list {
    margin-top: 60px;
    width: calc(100% + 9.2vw);
    margin-left: -4.6vw;
    overflow: auto hidden;
    padding: 0 4.6vw;
    &.column {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 200px));
      justify-content: center;
    }
    &.slider {
      display: flex;
      .item {
        width: 200px;
        min-width: 200px;
      }
    }
    .item {
      button {
        height: 0;
        padding-top: 100%;
        width: 200px;
        min-width: 200px;
        @include pc {
          &:hover {
            .item_title {
              opacity: 0;
            }
            .item_img::after {
              top: -3em;
            }
          }
        }
      }
      position: relative;
      &_title {
        position: absolute;
        top: 0;
        @include fz(16);
        margin: 8px;
        margin-bottom: 0;
        color: $text_white;
        @include text_overflow(2);
        font-weight: 500;
        transition: 0.3s;
      }
      &_img {
        overflow: hidden;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: #fff;
        @include zIndex(-1);
        &::after {
          @include pseudo(100%, 100%);
          top: 0;
          left: 0;
          height: 3em;
          background-color: $over_color;
          transition: 0.3s;
        }
        img {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          object-fit: cover;
        }
      }
      &_footer {
        position: absolute;
        bottom: 0;
        right: 0;
        @include fz(14);
        color: $text_black;
        margin: 8px;
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 30px;
      }
    }
    @include sp {
      width: 104%;
      margin-left: -2%;
      margin-top: 20px;
      padding: 20px 0;
      &.column {
        grid-template-columns: repeat(2, minmax(160px, 1fr));
      }
    }
  }
}
</style>